var _effectorFileName = "/src/shared/config/env.mjs";
import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';
export const env = createEnv({
  server: {},
  client: {
    NEXT_PUBLIC_APP_NAME: z.string().min(1),
    NEXT_PUBLIC_APP_VERSION: z.string().optional(),
    NEXT_PUBLIC_BUILD_TIME: z.string().optional(),
    NEXT_PUBLIC_APP_URL: z.string().min(1),
    NEXT_PUBLIC_API_ENDPOINT: z.string().min(1),
    NEXT_PUBLIC_API_ENDPOINT_NEW: z.string().min(1),
    NEXT_PUBLIC_APP_STAGE: z.string().min(1),
    NEXT_PUBLIC_OZON_PROMOCODE: z.string().min(1),
    NEXT_PUBLIC_SKLAD_PROMOCODE: z.string().min(1),
    NEXT_PUBLIC_TOCHKA_PROMOCODE: z.string().min(1),
    NEXT_PUBLIC_ENLERNO_PROMOCODE: z.string().min(1),
    NEXT_PUBLIC_TRIAL_LESSON_PROMOCODE: z.string().min(1),
    NEXT_PUBLIC_PAYKEEPER_LOGIN: z.string().min(1),
    NEXT_PUBLIC_PAYKEEPER_PASSWORD: z.string().min(1),
    NEXT_PUBLIC_PAYKEEPER_SERVER: z.string().min(1),
    NEXT_PUBLIC_API_YOO_KEY_TEST: z.string().min(1),
    NEXT_PUBLIC_API_YOO_SHOP_ID_TEST: z.string().min(1),
    NEXT_PUBLIC_API_YOO_KEY: z.string().min(1),
    NEXT_PUBLIC_API_YOO_SHOP_ID: z.string().min(1),
    NEXT_PUBLIC_TG_BOT_ID: z.string().min(1),
    NEXT_PUBLIC_TG_SUPPORT_URL: z.string().min(1),
    NEXT_PUBLIC_TG_SCHOOL_URL: z.string().min(1),
    NEXT_PUBLIC_LINKEDIN_URL: z.string().min(1),
    NEXT_PUBLIC_EMAIL_URL: z.string().min(1)
  },
  shared: {
    NODE_ENV: z.enum(['development', 'production', 'test']).default('development')
  },
  // If you're using Next.js < 13.4.4, you'll need to specify the runtimeEnv manually
  // runtimeEnv: {
  //   DATABASE_URL: process.env.DATABASE_URL,
  //   OPEN_AI_API_KEY: process.env.OPEN_AI_API_KEY,
  //   NEXT_PUBLIC_PUBLISHABLE_KEY: process.env.NEXT_PUBLIC_PUBLISHABLE_KEY,
  // },
  // For Next.js >= 13.4.4, you only need to destructure client variables:
  experimental__runtimeEnv: {
    NODE_ENV: process.env.NODE_ENV,
    NEXT_PUBLIC_APP_NAME: process.env.NEXT_PUBLIC_APP_NAME,
    NEXT_PUBLIC_APP_VERSION: process.env.NEXT_PUBLIC_APP_VERSION,
    NEXT_PUBLIC_BUILD_TIME: process.env.NEXT_PUBLIC_BUILD_TIME,
    NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL,
    NEXT_PUBLIC_API_ENDPOINT: process.env.NEXT_PUBLIC_API_ENDPOINT,
    NEXT_PUBLIC_API_ENDPOINT_NEW: process.env.NEXT_PUBLIC_API_ENDPOINT_NEW,
    NEXT_PUBLIC_APP_STAGE: process.env.NEXT_PUBLIC_APP_STAGE,
    NEXT_PUBLIC_OZON_PROMOCODE: process.env.NEXT_PUBLIC_OZON_PROMOCODE,
    NEXT_PUBLIC_SKLAD_PROMOCODE: process.env.NEXT_PUBLIC_SKLAD_PROMOCODE,
    NEXT_PUBLIC_TOCHKA_PROMOCODE: process.env.NEXT_PUBLIC_TOCHKA_PROMOCODE,
    NEXT_PUBLIC_ENLERNO_PROMOCODE: process.env.NEXT_PUBLIC_ENLERNO_PROMOCODE,
    NEXT_PUBLIC_TRIAL_LESSON_PROMOCODE: process.env.NEXT_PUBLIC_TRIAL_LESSON_PROMOCODE,
    NEXT_PUBLIC_PAYKEEPER_LOGIN: process.env.NEXT_PUBLIC_PAYKEEPER_LOGIN,
    NEXT_PUBLIC_PAYKEEPER_PASSWORD: process.env.NEXT_PUBLIC_PAYKEEPER_PASSWORD,
    NEXT_PUBLIC_PAYKEEPER_SERVER: process.env.NEXT_PUBLIC_PAYKEEPER_SERVER,
    NEXT_PUBLIC_API_YOO_KEY_TEST: process.env.NEXT_PUBLIC_API_YOO_KEY_TEST,
    NEXT_PUBLIC_API_YOO_SHOP_ID_TEST: process.env.NEXT_PUBLIC_API_YOO_SHOP_ID_TEST,
    NEXT_PUBLIC_API_YOO_KEY: process.env.NEXT_PUBLIC_API_YOO_KEY,
    NEXT_PUBLIC_API_YOO_SHOP_ID: process.env.NEXT_PUBLIC_API_YOO_SHOP_ID,
    NEXT_PUBLIC_TG_BOT_ID: process.env.NEXT_PUBLIC_TG_BOT_ID,
    NEXT_PUBLIC_YANDEX_METRICS_ID: process.env.NEXT_PUBLIC_YANDEX_METRICS_ID,
    NEXT_PUBLIC_GOOGLE_ANALYTICS_ID: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID,
    NEXT_PUBLIC_GOOGLE_TAG_ID: process.env.NEXT_PUBLIC_GOOGLE_TAG_ID,
    NEXT_PUBLIC_TG_SUPPORT_URL: process.env.NEXT_PUBLIC_TG_SUPPORT_URL,
    NEXT_PUBLIC_TG_SCHOOL_URL: process.env.NEXT_PUBLIC_TG_SCHOOL_URL,
    NEXT_PUBLIC_LINKEDIN_URL: process.env.NEXT_PUBLIC_LINKEDIN_URL,
    NEXT_PUBLIC_EMAIL_URL: process.env.NEXT_PUBLIC_EMAIL_URL
  },
  emptyStringAsUndefined: true,
  skipValidation: process.env.NODE_ENV === 'test'
});